import React from "react";

export default function ErrorBanner({ message, onRetry }) {
  if (!message) return null;

  return (
    <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-md mb-4 flex justify-between items-center">
      <span>{message}</span>
      {onRetry && (
        <button
          onClick={onRetry}
          className="ml-4 text-sm bg-red-100 hover:bg-red-200 text-red-700 px-3 py-1 rounded-md border border-red-300"
        >
          Retry
        </button>
      )}
    </div>
  );
}

